import { Col, Row } from 'react-bootstrap'
import GoogleAuthenticatorVerifyForm from './GoogleAuthenticatorVerifyForm'
import { useEffect, useState } from 'react'
import { MessageAlert, Spinner } from 'components'
import SmsMultiFactorVerifyForm from './SmsMultiFactorVerifyForm'
import { V1ApiUsersClient } from 'core/http-common'
import { startLoadingAction, endLoadingAction } from 'state/actions/appActions'
import { AppDispatch } from 'state/store'
import { useDispatch } from 'react-redux'
import GoogleAuthenticatorSetupForm from './GoogleAuthenticatorSetupForm'
import { AlertMessage } from 'types'
import { MultiFactorTypeEnum, MultiFactorVerifiedDto, UserMultiFactorSettingsJoinedDto } from '@v1UsersApi'

interface IProps {
    onSetup?: Function,
    onVerified?: (dto: MultiFactorVerifiedDto) => void
    onCancel?: Function
    message?: string
}

const MultiFactorSelectorForm = ({ onSetup, onVerified, onCancel, message }: IProps) => {
    const dispatch = useDispatch<AppDispatch>()
    const [selectedMultiFactor, setSelectedMultiFactor] = useState<MultiFactorTypeEnum>(MultiFactorTypeEnum.Google)
    const [loaded, setLoaded] = useState<boolean>(false)
    const [userGoogleSettings, setUserGoogleSettings] = useState<UserMultiFactorSettingsJoinedDto>()
    const [alert, setAlert] = useState<AlertMessage>({ variant: 'info', messages: [message ?? 'Please authenticate via 2FA.'] })

    const fetch = async () => {
        try {
            await dispatch(startLoadingAction())
            const response = await V1ApiUsersClient.getUserMultiFactorSettings()
            setUserGoogleSettings(response.data?.find(f => f.multiFactorTypeId === MultiFactorTypeEnum.Google))
        }
        catch (e) { }
        finally {
            await dispatch(endLoadingAction())
            setLoaded(true)
        }
    }

    useEffect(() => {
        fetch()
    }, [])

    const MultiFactorHandler = (multiFactorType: MultiFactorTypeEnum) => {
        switch (multiFactorType) {
            case MultiFactorTypeEnum.Google:
                if (!userGoogleSettings?.enabled) {
                    return <GoogleAuthenticatorSetupForm
                        onSetup={onSetup}
                        onVerificationRequired={() => setAlert({ variant: 'info', messages: ['SMS 2FA is required to complete the Google Authenticator setup.'] })}
                        onVerified={onVerified}
                    />
                }

                return <GoogleAuthenticatorVerifyForm
                    onVerified={onVerified}
                />

            case MultiFactorTypeEnum.Sms:
                return <SmsMultiFactorVerifyForm
                    onVerified={onVerified}
                />
        }
    }

    if (!loaded) {
        return (<Spinner center={true} />)
    }

    return (
        <Row>
            <Col md={{ span: 8, offset: 2 }}>
                <MessageAlert alert={alert} />
                <div className='bg-white shadow-sm p-3 border'>
                    {MultiFactorHandler(selectedMultiFactor)}
                </div>

                <div className='text-center'>
                    <div className='mt-2'>
                        {selectedMultiFactor !== MultiFactorTypeEnum.Sms
                            ? <a className='cursor-pointer' onClick={() => { setSelectedMultiFactor(MultiFactorTypeEnum.Sms) }}>
                                Authenticate using SMS (Text) instead?
                            </a>
                            : <a className='cursor-pointer' onClick={() => { setSelectedMultiFactor(MultiFactorTypeEnum.Google) }}>
                                Authenticate using Google Authenticator instead?
                            </a>
                        }
                    </div>
                    {
                        onCancel && <div className='mt-2'>
                            <a className='cursor-pointer' onClick={() => { onCancel() }}>
                                Cancel
                            </a>
                        </div>
                    }
                </div>
            </Col>
        </Row>
    )
}

export default MultiFactorSelectorForm